import React, { useMemo } from 'react';
import { useAtomValue } from 'jotai';



import { userAtom } from "../../atoms";








const checkWritePermissions = (
entities = [],
user = undefined) =>
{
  let granted = user !== undefined && user.role && entities.length > 0;
  let i = 0;
  while (granted && i < entities.length) {
    const entity = entities[i];
    i += 1;
    if (entity && entity.permissions) {
      const idsWithWritePermissions = entity.permissions.
      filter((p) => p.level === 'write').
      map((p) => p.refId);

      granted =
      idsWithWritePermissions.find(
        (id) => {var _user$groups;return id === (user === null || user === void 0 ? void 0 : user._id) || (user === null || user === void 0 ? void 0 : (_user$groups = user.groups) === null || _user$groups === void 0 ? void 0 : _user$groups.find((group) => group._id === id));}
      ) !== undefined;
    } else {
      granted = false;
    }
  }
  return granted;
};

const checkRole = (user, roles = ['admin']) =>
!!(user !== null && user !== void 0 && user._id && roles.includes(user.role));

const NeedAuthorization = ({ children, roles, orWriteAccessTo }) => {
  const user = useAtomValue(userAtom);
  const authorized = useMemo(
    () => checkRole(user, roles) || checkWritePermissions(orWriteAccessTo, user),
    [user, roles, orWriteAccessTo]
  );

  return authorized ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};

export { NeedAuthorization };